import { ensureDefined } from '@e-socna/utils';

export const nextPath = (path: readonly number[]): readonly number[] => {
  if (!path.length) {
    return [0];
  }

  const { last } = ensureDefined({ last: path[path.length - 1] });

  return [...path.slice(0, -1), last + 1];
};
